/*
  列表页的mixin文件
  mixin文档：http://cn.vuejs.org/v2/guide/mixins.html
*/

import * as api from 'src/api'
import * as common from 'src/config/common-config'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import vEmpty from 'src/components/common/v-empty'
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  Message,
  MessageBox
} from 'element-ui'
import { LS } from 'assets/js/storage'
import Print from 'components/modal/print'
import addNew from 'components/modal/add-new'
import detail from 'components/list/detail'
import listHead from 'components/list/list-head'
import listPanel from 'components/list/list-panel'
const listTable = resolve => require.ensure(['../components/list/list-table'], () => resolve(require('../components/list/list-table')), 'listTable')
import listFooter from 'components/list/list-footer'
import Export from 'components/modal/export'
import batchEdit from 'components/modal/batch-edit'

export const list = {
  data () {
    return {
      choosePrintType: false, // 打印组件的开关
      printIds: [],
      refType: '',
      refreshStatistics: true, // 是否刷新统计信息
      havePage: true, // 退回页码的开关
      currentPage: 1,
      pageRows: '',
      pageSize: Number(LS.get('VUE-pageSize')) || 20,
      pageSizes: [20, 30, 50, 100, 200], // 分页条数选项
      total: 0,
      detailShow: false,
      detailId: 0,
      addnewShow: false,
      addnewProp: {
        // id: id
      },
      listData: [],
      listHead: [],
      panelData: {},
      // 范围筛选
      belonger: {
        belongerType: '0',
        isMain: 1,
        treeType: '',
        pid: ''
      },
      // 搜索关键词
      nameLike: '',
      // 搜索关键词类型
      nameLikeType: '',
      // 归档
      archived: 0,
      // 模块名，用来传给详情页
      popModel: '',
      // 右上按钮权限
      topPermission: [],
      // 右上按钮对应关系
      topMap: common.topMap,
      // 底部权限列表
      botPermission: [],
      // 采购单总额
      totalMoneyAmount: 0,
      productArray: [], // 待采购产品
      supplierIdList: [], // 待采购产品供应商
      listTotalCount: 0, // 待采购、待入库、待出库列表数量
      // 库存预警
      amount: 0,
      // 导出
      exportShow: false,
      creating: true, // 数据生成状态
      // 模块对应名称
      moduleMap: common.moduleMap,
      // 是否有操作按钮
      hasListMenu: false,
      // 初始化table，用于子页面
      showTable: true,
      batchEditShow: false, // 合并编辑
      hasInvoiceMenu: false, // 是否开发票
      summaryInfo: [], // 底部统计信息
      sortArray: [], // 可以排序的列
      opUUID: '',
      review: 0,
      reportType: 0,
      arr: [],
      page: 1,
      templateList: [], // 模板列表
      curTemplate: {}, // 当前模板
      foldTemplate: {}, // 折叠时显示的模板
      foldTemplateList: [], // 折叠的模板列表
      isToggleTemplate: false, // 是否是切换模板
      emptyStr: '' // 空白页的提示语
    }
  },
  computed: {
    ...mapGetters([
      'freshList',
      'moduleName',
      'advancedFilter',
      'normalFilter',
      'sortObj',
      'getSelectIds',
      'getRefInfos',
      'getCTIEmit',
      'getPage',
      'getSpecialEnmus',
      'getAliasList',
      'freshAllList'
    ]),
    // 子页面
    routeChild () {
      return this.$route.path.split('/').pop()
    }
  },
  methods: {
    // 初始化列表页
    ...mapActions([
      'initList',
      'updateSelectrows',
      'setListLoading',
      'setPaymentType',
      'initPayment',
      'updateVuexPage',
      'setContactType',
      'setFreshAllList',
      'switchAdvanced',
      'reset'
    ]),
    // 获取业务模板列表
    getTemplateList () {
      this.emptyStr = '数据请求中，请稍后'
      let url = `/${this.moduleName}/templateList.do`
      api.post(url, {}, (data) => {
        this.templateList = data.result
        if (!this.templateList.length) {
          this.emptyStr = '您暂无此模块业务模板的使用权限，请联系管理员进行配置（设置-常用设置-业务模版 中设置使用权限）'
        } else {
          this.emptyStr = '数据请求中，请稍后'
        }
        // 获取ls中存的之前保存的选中的模板
        let lsModuleStr = 'VUE-' + this.moduleName + '-' + this.routeChild + '-template'
        let cacheTemplate = LS.get(lsModuleStr) || {}
        // 将当面模板先默认置为第一个
        this.curTemplate = this.templateList[0] || {}
        // 模板数量大于3个时，将第三个模板作为折叠位置显示出来
        this.templateList.length > 3 && (this.foldTemplate = data.result[2] || {})
        // 模板数量大于3个时，多出的折叠，并且遍历ls中的模板是否在模板列表中，在就选中，不在就继续选中第一个
        this.foldTemplateList = data.result.filter((item, i) => {
          if (item.key === cacheTemplate.key) {
            this.curTemplate = cacheTemplate
            i > 1 && (this.foldTemplate = this.curTemplate)
          }
          return i > 1 ? item : false
        })
        // 有模板才获取列表，这里需要加nextTick因为templateList变化是同时变化的，需要有一个顺序
        this.templateList.length && this.$nextTick(() => {
          this.setFreshAllList(!this.freshAllList)
        })
        // 附近客户有模板时需要初始化地图
        this.templateList.length && this.initMap && this.initMap()
      })
    },
    // 切换业务模板
    toggleTemplate (template, type) {
      if (template.key === this.curTemplate.key || this.isToggleTemplate) {
        return
      }
      if (type !== 'click') {
        this.foldTemplate = template
      }
      this.curTemplate = template
      let lsModuleStr = 'VUE-' + this.moduleName + '-' + this.routeChild + '-template'
      LS.set(lsModuleStr, template)
      this.updateSelectrows({
        del: 'all'
      })
      this.isToggleTemplate = true
      this.reset()
      this.$nextTick(() => {
        this.listHead = []
        this.listData = []
        this.setFreshAllList(!this.freshAllList)
      })
    },
    // 待采购按钮数量
    getTotalCount () {
      let url = ``
      if (this.moduleName === 'purchase') {
        url = `/waitPurchaseApi/showWaitPurchaseMenu.html`
      } else if (this.moduleName === 'instock') {
        url = `/waitInstockPurchase/showWaitInstockMenu.html`
      } else if (this.moduleName === 'outstock') {
        url = `/waitOutstock/showWaitOutstockMenu.html`
      } else if (this.moduleName === 'productionOrder') {
        url = `/waitProduce/showWaitProduceMenu.html`
      }
      api.post(url, {}, (data) => {
        this.listTotalCount = data.totalCount
      })
    },

    // 待采购订单跳转
    gotowForLisit () {
      this.$router.push({
        path: 'wForPurchase',
        query: {
          moduleName: 'waitPurchaseApi'
        }
      })
    },
    // 待入库跳转
    gotoWaitInstock () {
      this.$router.push({
        path: 'waitInstock',
        query: {
          moduleName: 'waitInstockPurchase'
        }
      })
    },
    // 待出库跳转
    gotoWaitOutstock () {
      this.$router.push({
        path: 'waitOutstock',
        query: {
          moduleName: 'waitOutstock'
        }
      })
    },
    // 待生产跳转
    gotoWaitProduce () {
      this.$router.push({
        path: 'waitProduce',
        query: {
          moduleName: 'waitProduce'
        }
      })
    },
    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      LS.set('VUE-pageSize', val)
      this.refreshStatistics = false // 关闭刷新统计信息
      this.getList()
    },
    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.listData = []
      this.refreshStatistics = false // 关闭刷新统计信息
      this.getList()
    },
    // 归档筛选
    archiveChange (val) {
      this.getList()
    },
    // 切换模板时清空已选值
    clearSelectValue () {
      this.archived = 0
      this.nameLike = ''
      this.reset()
      this.$refs.listHead.search = ''
    },
    // 获取列表数据
    getList (resetPage) {
      if (resetPage) {
        this.currentPage = 1
      }
      // 开始loading动画
      this.setListLoading(true)
      let url = ``
      // 预警时候请求不同接口
      if (this.allPromanager === 1) {
        url = `/${this.moduleName}/warningListAjax.html`
      } else if (this.allPromanager === 2) {
        url = `/${this.moduleName}/guaranteeListAjax.html`
      } else {
        url = `/${this.moduleName}/listAjax.html`
      }
      let params = {
        templateId: this.curTemplate.key || '',
        page: this.currentPage,
        pageSize: this.pageSize,
        belongerType: this.belonger.belongerType,
        isMain: this.belonger.isMain,
        treeType: this.belonger.treeType,
        pid: this.belonger.pid,
        nameLike: this.nameLike || '',
        nameLikeType: this.nameLikeType || '',
        isArchived: this.archived,
        child: this.routeChild,
        categoryId: this.categoryId || ''
      }

      // 使用待采购待入库待出库新建编辑取消退到数据所在页面
      if (this.$route.params.page && this.havePage) {
        params.page = this.$route.params.page
        params.belongerType = this.$route.params.belongerType
      }

      if ([1].indexOf(this.allPromanager) > -1) {
        params.warningType = this.warningValue
      }
      if ([2].indexOf(this.allPromanager) > -1) {
        params.guaranteeStatus = this.guaranteeValue
      }

      // 发票管理 作废筛选
      if (this.moduleName === 'invoice') {
        params.status = this.cancel
      }
      // 常用筛选
      for (let i in this.normalFilter) {
        params[i] = this.normalFilter[i]
      }
      // 高级筛选
      for (let i in this.advancedFilter) {
        params[i] = this.advancedFilter[i]
      }
      // 排序
      for (let i in this.sortObj) {
        params[i] = this.sortObj[i]
      }
      if (['contractApi', 'paymentApi'].includes(this.moduleName) && this.refreshStatistics) { // 单独请求获取统计信息（开启统计信息刷新的状况下）
        this.statistics(params)
      }

      api.post(url, params, (data) => {
        if (data.opUUID) {
          this.opUUID = data.opUUID
        }
        this.refreshStatistics = true // 统计信息刷新开启
        this.sortArray = []
        // 筛选出可以排序的表头
        data.explains.forEach(obj => {
          if (obj.sort === 1) {
            this.sortArray.push(obj)
          }
        })
        this.total = data.pageHelper.rowsCount
        if (this.curTemplate.key && this.$refs.table) {
          this.$refs.table.filterShow()
        }

        this.$nextTick(() => {
          this.isToggleTemplate = false
          this.listHead = data.explains
          this.listData = data.resultMap
        })

        if (!data.resultMap.length) {
          this.emptyStr = '暂无数据'
        }
        if (!['contractApi', 'paymentApi'].includes(this.moduleName)) { // 单独请求获取统计信息
          this.summaryInfo = data.summaryInfo // 统计信息
        }
        this.totalMoneyAmount = data.totalMoneyAmount || 0 // 采购单金额
        this.topPermission = data.topPermissionSet || []
        this.refType = data.refType // 业务id
        this.botPermission = data.bottomPermissionSet || []
        this.amount = data.amount || 0 // 库存预警
        this.hasListMenu = data.hasListMenu
        this.hasInvoiceMenu = data.hasInvoiceMenu
        setTimeout(() => {
          this.showTable = true
        }, 300)
        // 库存查询预警数
        if ([1, 2].indexOf(this.allPromanager) === -1) {
          if (this.moduleName === 'productStock') {
            this.overdueNum = data.overdueNum // 保质
            this.warningNum = data.warningNum // 预警
          }
        }

        // 开结束loading动画
        this.setListLoading(false)
        // 使用待采购待入库待出库新建编辑取消退到数据所在页面页码
        if (this.$route.params.page && this.havePage) {
          this.belonger.belongerType = this.$route.params.belongerType
          this.currentPage = this.$route.params.page
          this.havePage = false
        }
      }, (errorData) => {
        // 开结束loading动画
        this.isToggleTemplate = false
        this.setListLoading(false)
      })
    },
    // 统计信息单独请求
    statistics (params) {
      let url = `/${this.moduleName}/listStatistics.html`
      this.summaryInfo = [{value: '', attr: ''}] // 占位，否则数据更新后，dom样式没有被重新渲染
      api.post(url, params, (data) => {
        this.summaryInfo = data.summaryInfo // 统计信息
      })
    },
    // 操作成功
    success () {
      // 同步到vuex
      this.updateSelectrows({
        del: 'all'
      })
      this.getList()
    },
    // 打开详情页
    openDetail (id, popModel) {
      if (popModel) {
        if (popModel === 'salesOpportunity') {
          this.popModel = 'opportunityApi'
        } else if (popModel === 'contract') {
          this.popModel = 'contractApi'
        } else {
          this.popModel = popModel
        }
      } else {
        this.popModel = this.moduleName
      }
      this.detailId = id
      this.detailShow = true
    },
    closeDetail (module) {
      this.detailShow = false
      if (this.moduleName === module) {
        this.getList()
      }
    },
    // 撤回
    handleRecall (id) {
      MessageBox.confirm(`${this.moduleMap[this.moduleName]}正在审批中，是否要进行撤回?`, '撤回确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = `/approval/recall.html`
        let params = {
          refId: id,
          refType: this.moduleName
        }
        api.post(url, params, (data) => {
          Message({
            type: 'success',
            message: '撤回成功!'
          })
          this.getList()
        })
      }).catch((err) => {
        console.warn(err)
      })
    },

    // 打开新建窗口
    openAddnew (prop) {
      // 非进销存新建编辑，以弹窗形式打开
      if (['purchase', 'instock', 'outstock', 'returnedPurchase', 'assemble', 'transfer', 'inventory', 'waitPurchaseApi', 'productApi', 'waitInstockPurchase', 'waitOutstock', 'waitProduce', 'bomBill', 'productionOrder'].indexOf(this.moduleName) === -1) {
        if ((prop && prop.module === 'contractApi') || ((!prop || (prop && !prop.module)) && this.moduleName === 'contractApi')) {
          let str = prop && prop.id ? 'edit' : 'item'
          this.setPaymentType('contractApi-' + str)
          this.initPayment()
        }
        if (!this.addnewShow) {
          this.addnewShow = true
        } else {
          // 获取子组件的props
          const childAnp = this.$refs.addNew.addnewProp // 已经传给子组件的props
          const parentAnp = this.addnewProp // 即将传给子组件的props
          /*
            * childAnp 条件成立时，说明新建窗口被打开过，并且没有被销毁
            * childAnp.id，有id值，说明上一次是编辑操作
            * childAnp.module 有module，说明上一次操作是另一个模块的新建动作
            * parentAnp 存在id属性说明当前操作时编辑，不是新建
            * parentAnp 存在module属性说明当前要打开另一个模块的新建
          */
          if (childAnp && childAnp.id || childAnp && childAnp.module || parentAnp.id || parentAnp.module || parentAnp.originId || parentAnp.paymentId) {
            this.addnewShow = false
            this.$nextTick(() => {
              this.openAddnew()
            })
          } else {
            if ((prop && prop.module === 'customerApi') || (prop && prop.moduleName === 'customerApi')) {
              let id = prop.id ? prop.id : 'item'
              let str = 'customerApi-' + id
              this.setContactType(str)
            } else if (!prop && this.moduleName === 'customerApi') {
              let str = 'customerApi-item'
              this.setContactType(str)
            }
            this.$refs.addNew.dialogFormVisible = true
          }
        }
      } else if (['waitPurchaseApi'].indexOf(this.moduleName) > -1) {

        // if (this.supplierIdList.length) {
        // 待采购新建
        // 同时存到本地，防止刷新页面后数据丢失
        LS.set('VUE-supplierIdList', this.supplierIdList)
        LS.set('VUE-productArray', this.productArray)
        this.$router.push({
          name: 'jxcAddPage',
          query: {
            moduleName: 'purchase',
            id: '',
            type: 'waitPurchaseApi'
          },
          params: {
            moduleName: 'purchase',
            id: '',
            roterName: 'waitPurchaseApi',
            supplierIdList: this.supplierIdList,
            productArray: this.productArray
          }
        })
        // } else {
        //   Message({
        //     type: 'warning',
        //     message: '选中产品没有供应商'
        //   })
        //   return false
        // }
      } else if (['waitProduce'].indexOf(this.moduleName) > -1) {
        // 待生产新建
        // 同时存到本地，防止刷新页面后数据丢失
        LS.set('VUE-productArray', this.productArray)
        this.$router.push({
          name: 'jxcAddPage',
          query: {
            moduleName: 'productionOrder',
            id: '',
            type: 'waitProduce'
          },
          params: {
            moduleName: 'productionOrder',
            id: '',
            roterName: 'waitProduce',
            productArray: this.productArray
          }
        })
      } else if (['waitInstockPurchase'].indexOf(this.moduleName) > -1) {
        // 待入库
        this.$router.push({
          name: 'jxcAddPage',
          query: {
            moduleName: 'instock',
            refId: prop,
            type: 'purchase'
          },
          params: {
            roterName: 'waitInstockPurchase'
          }
        })
      } else if (['waitOutstock'].indexOf(this.moduleName) > -1) {
        // 待出库
        this.$router.push({
          name: 'jxcAddPage',
          query: {
            moduleName: 'outstock',
            refId: prop,
            type: 'contractApi'
          },
          params: {
            roterName: 'waitOutstock'
          }
        })
      } else {
        // jxc编辑
        this.$router.push({
          name: 'jxcAddPage',
          query: {
            moduleName: this.moduleName,
            id: prop || ''
          },
          params: {
            moduleName: this.moduleName,
            id: prop || ''
          }
        })
      }
    },
    // 新建表单
    addnew () {
      this.addnewProp = {}
      if (this.curTemplate.key) {
        this.addnewProp.templateId = this.curTemplate.key
      }
      this.openAddnew()
    },
    // 业务流转生成表单
    newWorkFlow (obj) {
      this.addnewProp = obj
      this.openAddnew()
    },
    // 编辑行
    editItem (prop, relationid) {
      if (typeof prop === 'number') {
        this.addnewProp = {
          id: prop
        }
        if (relationid) {
          this.addnewProp.relationId = relationid
        }
      } else {
        this.addnewProp = prop
      }
      this.openAddnew(prop)
    },

    //  列表页发票的红冲和回款的红冲
    addRedTicket (id, btn) {
      if (this.moduleName === 'paymentApi') {
        this.addnewProp = {
          module: 'paymentSheetApi',
          formTitle: '红冲回款',
          paymentId: id,
          modelType: 'red',
          isRed: 1
        }
      } else if (this.moduleName === 'invoice') {
        this.addnewProp = {
          originId: id,
          formTitle: '红冲发票开票'
        }
      }
      this.openAddnew()
    },

    // 一键采购
    goToPurchase (supplierIdList, productArray) {
      this.supplierIdList = supplierIdList
      this.productArray = productArray
      this.openAddnew()
    },
    // 一键生产
    goToProduce (productArray) {
      this.productArray = productArray
      this.openAddnew()
    },

    // 批量采购
    checkedPurchase (arr) {
      this.productArray = []
      arr.map(item => {
        if (item.supplierIdList) {
          this.supplierIdList = this.supplierIdList.concat(item.supplierIdList)
        }
        let obj = {
          productId: item.productId,
          num: item.num
        }
        this.productArray.push(obj)
      })
    },

    // table 列 过滤
    refreshTable () {
      if (this.$refs.table) {
        this.$refs.table.filterShow()
      }
      this.getList()
    },
    // 删除选中的行
    deleteRows () {
      this.$refs.table.deleteArr()
    },
    // 页面右上角的搜索
    search (key) {
      this.currentPage = 1
      this.nameLike = key.trim()
      this.getList()
    },
    // 取消table选中操作
    cancelTableCheck (id) {
      this.$refs.table.handleSelect(id)
    },
    // 是否显示导出选择模板弹窗
    ifChooseExportTemplate () {
      // 客户和合同不用选择模板直接导出
      if (['customerApi', 'contractApi'].indexOf(this.moduleName) > -1) {
        this.exportFile(this.curTemplate.key)
      } else { // 其它模块弹出选择框
        this.exportShow = true
      }
    },
    // 右上按钮
    topBtnHandle (method) {
      if (method === 'checkRepeat') {
        this.checkRepeate()
      } else if (method === 'export') {
        // 显示导出窗口
        this.ifChooseExportTemplate()
      } else if (method === 'waitPurchase') {
        // 待采购
        this.gotowForLisit()
      } else if (method === 'waitInstock') {
        // 待入库
        this.gotoWaitInstock()
      } else if (method === 'waitOutstock') {
        // 待出库
        this.gotoWaitOutstock()
      } else if (method === 'waitProduce') {
        // 待生产
        this.gotoWaitProduce()
      } else {
        this.uploadImport(method)
      }
    },
      // 关闭打印组件
    closePrint () {
      this.choosePrintType = false
    },
    // 导入
    uploadImport (type) {
      if (type === 'import') {
        // 李正要求这么改的
        type = this.moduleName.replace('Api', '')
        if (type === 'opportunity') {
          type = 'salesOpportunity'
        }
      }
      let url = `/uploadExcel.html?type=${type}`
      url = utils.openBlankUrl(url)
      window.open(url)
    },
    // 执行导出
    exportFile (tempId) {
      this.closeExport()
      this.downloadExport(tempId)
      setTimeout(() => {
        this.getExportEnd()
      }, 1000)
    },

    // 监听导出结束
    getExportEnd () {
      const url = '/getDownloadExportFlag.do'
      let params = {
        exportType: this.moduleName,
        templateId: this.curTemplate.key || ''
      }
      // 工作报告
      if (this.moduleName === 'workReportApi') {
        params.reportType = this.reportType
      }

      // 库存查询
      if (this.moduleName === 'productStock') {
        if (this.allPromanager === 1) {
          params.stockType = 'warningSearch'
        } else if (this.allPromanager === 2) {
          params.stockType = 'guaranteeSearch'
        } else {
          params.stockType = 'stockSearch'
        }
      }

      api.post(url, params, (data) => {
        if (data.end) {
          if (data.msg) {
            Message(
              {
                message: data.msg,
                duration: 6000,
                type: 'success'
              })
          }
        } else {
          setTimeout(this.getExportEnd, 1000)
        }
      })
    },

    // 下载导出文件
    downloadExport (tempId) {
      const url = this.getSpecialEnmus.export
      let params = {
        templateId: this.curTemplate.key || '',
        belongerType: this.belonger.belongerType,
        isMain: this.belonger.isMain,
        treeType: this.belonger.treeType,
        pid: this.belonger.pid,
        nameLike: this.nameLike || '',
        nameLikeType: this.nameLikeType || '',
        isArchived: this.archived,
        categoryId: this.categoryId || '',
        isExport: 1,
        exportTemplateId: tempId,
        idArray: this.getSelectIds,
        exportType: this.moduleName,
        child: this.routeChild
      }

      // 库存查询导出
      if (this.allPromanager === 1) {
        params.stockType = 'warningSearch'
        params.warningType = this.warningValue
      } else if (this.allPromanager === 2) {
        params.stockType = 'guaranteeSearch'
        params.guaranteeStatus = this.guaranteeValue
      } else {
        params.stockType = 'stockSearch'
      }
      // 导出
      for (var i in this.belonger) {
        params[i] = this.belonger[i]
      }
      // 工作报告
      if (this.moduleName === 'workReportApi') {
        params.reportType = this.reportType
        params.reportDate = this.arr
        params.reviewType = this.review
      } else if (this.routeChild === 'isNearby') {
        params.longitude = this.longitude
        params.latitude = this.latitude
        // 发票管理 作废筛选
      } else if (this.moduleName === 'invoice') {
        params.status = this.cancel
      } else if (this.moduleName === 'communicatePlan') {
        Object.assign(params, this.form)
      } else if (this.moduleName === 'communicateApi') {
        params.memo = this.memo || ''
      }
      // 常用筛选
      for (let i in this.normalFilter) {
        params[i] = this.normalFilter[i]
      }
      // 高级筛选
      for (let i in this.advancedFilter) {
        params[i] = this.advancedFilter[i]
      }
      // 排序
      for (let i in this.sortObj) {
        params[i] = this.sortObj[i]
      }

      api.post(url, params, (data) => {})
    },
    // 关闭导出弹窗
    closeExport () {
      this.exportShow = false
    },
    // 批量编辑
    handelBatchEdit () {
      this.batchEditShow = true
    },
    handelBatchPrint () {
      this.printIds = this.getSelectIds
      this.choosePrintType = true
    },
    // 客户批量操作
    handlePerm (type) {
      let len = this.getSelectIds.length
      if (len) {
        switch (type) {
          case 'distribution':
            this.distribution()
            break
          case 'handover':
            this.handover()
            break
          case 'backCustomer':
            this.setPublic()
            break
          case 'backO2oCustomer':
            this.setSuperior()
            break
          case 'addVisitPlan':
            this.addVisitPlan()
            break
          case 'editCustomerStatus':
            this.editCustomerStatus()
            break
          case 'addTeamPerson':
            this.teamPerson()
            break
          case 'archiveBatch':
            this.archivedRows()
            break
          case 'communicateNotify':
            this.multRemind()
            break
          case 'sendSMS':
            this.sendMsg()
            break
          case 'getCustomer':
            this.getCustomer()
            break
          case 'revertBatch':
            this.revertBatch()
            break
          case 'removeCompletely':
            this.handleDelete()
            break
          case 'batchEdit':
            this.handelBatchEdit()
            break
          case 'batchPrint':
            this.handelBatchPrint()
            break
          case 'cancel':
            this.cancelHandle(len, 'cancel')
            break
          case 'setPaid':
            this.setPaid()
            break
          case 'mInvoice':
            this.mergeInvoice()
            break
          case 'revertCancel':
            this.cancelHandle(len, 'revertCancel')
            break
          case 'userPortion':
            this.handeDistribution(0)
            break
          case 'depPortion':
            this.handeDistribution(1)
            break
          case 'online':
            this.handeOnOffline(1) // 1上架
            break
          case 'offline':
            this.handeOnOffline(2) // 2上架
            break
          case 'purchase':
            this.batchPurchase() // 一键采购
            break
          case 'finish':
            let emitObj = {
              type: 'finish'
            }
            this.handlefinish(emitObj) // 生产单批量完成
            break
          default:
            console.warn(type)
        }
      } else {
        Message({
          type: 'warning',
          message: '未选中任何数据!'
        })
      }
    }
  },
  components: {
    listHead,
    listPanel,
    listTable,
    listFooter,
    detail,
    addNew,
    Export,
    Print,
    batchEdit,
    vEmpty
  },

  directives: {
    Clickoutside
  },
  watch: {
    // 监听 vuex中的freshList，当值被改变时，刷新列表
    freshList () {
      this.currentPage = 1
      if (['signInApi', 'communicateApi', 'approvalApi'].indexOf(this.moduleName) > -1 || this.routeChild === 'isNearby') {
        this.getList2(1)
      } else {
        this.getList()
      }
    },

    // 监听页码,更新vuex页面
    currentPage (old, number) {
      let updateVuexObj = {
        currentPage: this.currentPage,
        belongerType: this.belonger.belongerType
      }
      this.updateVuexPage(updateVuexObj)
    },

    // 监听vuex中的CTIEmit，当值被改变时，调起新建或详情页面
    getCTIEmit: {
      handler () {
        const popType = {
          '2': 'customerApi',
          '3': 'contactApi'
        }
        const obj = this.getRefInfos
        // 关闭当前的新建和详情窗口
        this.addnewShow = this.detailShow = false
        this.$nextTick(() => {

          // 查看客户或联系人详情
          if (obj.refId) {
            this.popModel = popType[obj.refType]
            this.detailId = obj.refId
            if (this.moduleName === 'approvalApi' || this.moduleName === 'workOrder') {
              this.detailName = popType[obj.refType]
            }
            this.detailShow = true
          } else {
            // 新建客户
            this.addnewProp = {
              module: 'customerApi',
              phone: obj.phone
            }
            this.openAddnew()
          }
        })
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/mixin.js